import request from '@/service/request';

export const getProducts = () => {
  return request.get('/v1/agency-platform-vn-v2/agency/product_categories');
};
